import { format } from 'date-fns';

export const ARTICLE_DATE_FORMAT = 'DD.MM.YYYY';

export const formatArticleDate = dateString => format(dateString, ARTICLE_DATE_FORMAT);
